!(function () {
  "use strict";
  var t,
    e = {
      6072: function (t, e, r) {
        r.d(e, {
          Ds: function () {
            return o;
          },
          Q2: function () {
            return n;
          },
        });
        const n = function () {
          return {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: `application/${
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : "json"
              }`,
            },
          };
        };
        function o(t, e) {
          const r = this;
          let n;
          return function () {
            for (var o = arguments.length, a = new Array(o), c = 0; c < o; c++)
              a[c] = arguments[c];
            clearTimeout(n),
              (n = setTimeout(function () {
                return t.apply(r, a);
              }, e));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), t.stopPropagation();
            const e = t.target.getAttribute("href");
            !(function (t) {
              let e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0;
              const r = document.getElementById("nav-wrapper"),
                n = document
                  .querySelector(".header")
                  .getAttribute("data-ux-position"),
                o = t.getBoundingClientRect().top;
              window.scrollTo({
                top:
                  "off" !== n
                    ? o + window.scrollY - e + parseFloat(r.style.marginTop)
                    : o + window.scrollY - e,
                behavior: "smooth",
              });
            })(document.querySelector(e));
          });
        });
      },
    },
    r = {};
  function n(t) {
    var o = r[t];
    if (void 0 !== o) return o.exports;
    var a = (r[t] = { exports: {} });
    return e[t](a, a.exports, n), a.exports;
  }
  (n.d = function (t, e) {
    for (var r in e)
      n.o(e, r) &&
        !n.o(t, r) &&
        Object.defineProperty(t, r, { enumerable: !0, get: e[r] });
  }),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (t = n(6072)),

    (window.cartInstance = new (class {
      constructor() {
        this.mainCartSelector = ".shopify-section.cart";
        this.miniCart = document.getElementById("mini-cart");
        this.itemsContainersSelector =
          ".cart-items-container, .cart__empty, .mini-cart--empty";
        this.parser = new DOMParser();

        Array.from(document.querySelectorAll(".cart-item")).forEach((item) =>
          this.manageState(item)
        );
        
        this.setupCheckoutButtonObserver();
      }
      
      setupCheckoutButtonObserver() {
      }

      getCurrency() {
        return window.Shopify?.currency?.active || "NZD";
      }

      formatPrice(cents) {
        const currency = this.getCurrency();
        const locale = currency === "AUD" ? "en-AU" : "en-NZ";
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
        }).format(cents / 100);
      }

      manageState(item) {
        const qtyInput = item.querySelector('input[name="quantity"]');
        if (!qtyInput) return;

        const lineKey = qtyInput.getAttribute("data-line-key") || item.getAttribute("data-line-key");
        if (!lineKey) {
          return;
        }

        let qty = parseInt(qtyInput.value);

        item
          .querySelector(".cart-item-delete, .cart-item__remove")
          ?.addEventListener("click", async () => {
            await this.changeCartItem({ id: lineKey, quantity: 0 });
            item.remove();
          });

        item
          .querySelector('button[name="plus"]')
          ?.addEventListener("click", async () => {
            qty += 1;
            qtyInput.value = qty;
            await this.changeCartItem({ id: lineKey, quantity: qty });
          });

        item
          .querySelector('button[name="minus"]')
          ?.addEventListener("click", async () => {
            qty = Math.max(0, qty - 1);
            qtyInput.value = qty;
            await this.changeCartItem({ id: lineKey, quantity: qty });
          });

        qtyInput.addEventListener("change", async (e) => {
          const val = parseInt(e.target.value);
          if (val > 0) {
            qty = val;
            await this.changeCartItem({ id: lineKey, quantity: qty });
          } else {
            qtyInput.value = qty;
          }
        });
      }


      async changeCartItem({ id, quantity }) {
        try {
          const opts = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id, 
              quantity,
              sections: "main-cart",
            }),
          };
          const res = await fetch("/cart/change.js", opts);
          const json = await res.json();
          
          if (!res.ok) {
            const errorMessage = json.message || json.description;
            if (errorMessage && errorMessage !== 'no valid id or line parameter') {
              const errorEl = document.createElement('div');
              errorEl.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #d32f2f; color: white; padding: 16px 24px; border-radius: 8px; z-index: 99999; max-width: 400px; box-shadow: 0 4px 12px rgba(0,0,0,0.3);';
              errorEl.textContent = errorMessage;
              document.body.appendChild(errorEl);
              
              setTimeout(() => {
                errorEl.style.transition = 'opacity 0.3s';
                errorEl.style.opacity = '0';
                setTimeout(() => errorEl.remove(), 300);
              }, 4000);
            }
            await this.updateMiniCart();
            return;
          }

          await this.updateMiniCart();
        } catch (error) {
          try {
            await this.updateMiniCart();
          } catch (e) {
            console.error("Cart update error:", e);
          }
        }
      }

      async addCartItem(variantId, quantity = 1) {
        try {

          const resAdd = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id: variantId, quantity }),
          });
          if (!resAdd.ok) throw new Error("Add to cart failed");

          await this.updateMiniCart(true);
        } catch (err) {
          console.error("[mini-cart] error in addCartItem:", err);
        }
      }

      async updateMiniCart(openDrawer = false) {
        const buttonContainer = document.querySelector('.cart-summary__buttons');
        const originalVisibility = buttonContainer?.style.visibility;
        
        try {
          if (buttonContainer) {
            buttonContainer.style.visibility = 'hidden';
          }
          
          const res = await fetch(`${window.location.pathname}?section_id=main-cart`);
          const html = await res.text();
          const tmp = document.createElement("div");
          tmp.innerHTML = html;

          let cart;
          try {
            cart = await fetch("/cart.js").then((r) => r.json());
            
            document
              .querySelectorAll(".cart-count, .header__cart-count")
              .forEach((el) => (el.textContent = cart.item_count));
            
            const summaryCount = document.querySelectorAll('.cart-summary__header .cart-summary__count');
            summaryCount.forEach(el => {
              el.textContent = cart.item_count === 1 ? '1 item' : `${cart.item_count} items`;
            });
            
            const totalPriceEls = document.querySelectorAll('.cart-summary__line-total p:last-child, .cart-summary__line-subtotal p:last-child');
            totalPriceEls.forEach(el => {
              el.textContent = this.formatPrice(cart.total_price);
            });
          } catch (error) {
            console.error("Mini cart update error:", error);
          }
          
          setTimeout(() => {
            if (buttonContainer) {
              buttonContainer.style.visibility = originalVisibility || '';
            }
          }, 50);

          const progressBar = document.querySelector('.cart-drawer__progress-bar');
          const freeShippingBar = document.querySelector('.free-shipping-bar');
          const closeTitle = document.querySelector('.cart-drawer__close-title');
          const miniCartFooter = document.querySelector('.mini-cart__footer');
          const miniCartContent = document.querySelector('.mini-cart__content');
          const checkoutBtn = document.getElementById('checkout');

          if (cart && cart.item_count === 0) {
            progressBar?.classList.add('cart-drawer__empty');
            freeShippingBar?.classList.add('cart-drawer__empty');
            closeTitle?.classList.add('cart-drawer__empty');
            miniCartFooter?.classList.add('cart-drawer__empty');

            if (miniCartContent) {
              miniCartContent.innerHTML = `
                <div class="mini-cart--empty">
                  <p class="text-lg">Your cart is empty</p>
                  <p>There are no items in your cart.</p>
                  <a tabindex="0" href="/collections/all" class="button--primary  button--icon_left">
                    <span class="button__text">Continue shopping</span>
                  </a>
                </div>
              `;
            }

            checkoutBtn?.setAttribute('disabled', '');

            try { localStorage.removeItem('bundleProducts'); } catch (e) {}
          } else {
            progressBar?.classList.remove('cart-drawer__empty');
            freeShippingBar?.classList.remove('cart-drawer__empty');
            closeTitle?.classList.remove('cart-drawer__empty');
            miniCartFooter?.classList.remove('cart-drawer__empty');


            checkoutBtn?.removeAttribute('disabled');
          }

          Array.from(document.querySelectorAll(".cart-item")).forEach((item) =>
            this.manageState(item)
          );

          if (openDrawer) {
            const drawer = document.querySelector("drawer-component.mini-cart") || document.querySelector("drawer-component");
            if (drawer) drawer.setAttribute("open", "");
            document.documentElement.classList.add("cart-open");
          }
        } catch (err) {
          console.error("[updateMiniCart] error:", err);
        }
      }

    })());

  // ===========================
  // cart-note
  // ===========================
  customElements.get("cart-note") ||
    customElements.define(
      "cart-note",
      class extends HTMLElement {
        constructor() {
          super();
          this.querySelector("textarea").addEventListener(
            "change",
            (0, t.Ds)((e) => {
              const r = JSON.stringify({ note: e.target.value });
              fetch(`${routes.cartUpdate}`, { ...(0, t.Q2)(), body: r });
            }, 300)
          );
        }
      }
    );

  // ===========================
  // Скрипт upsell
  // ===========================
  document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", async (e) => {
      const btn = e.target.closest(".card-upsell__btn");
      if (!btn || !window.cartInstance) return;
      e.preventDefault();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      try {
        await window.cartInstance.addCartItem(variantId, 1);
      } catch (err) {
        console.error("[mini-cart] error:", err);
      }
    });
  });
})();
